// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"Checkbox_checkbox__3vQWp","input":"Checkbox_input__1FIzP","label":"Checkbox_label__5mAfG","radio":"Checkbox_radio__WjyYU"};